import { Mask } from "./Mask";
import { masks } from "./masks";

export class CepMask implements Mask {
  searchValue = masks.cep.searchValue;
  replaceValue = masks.cep.replaceValue;
  maxLength = 8;

  execute(value: string): string {
    // Remove qualquer caractere que não seja número
    const numericValue = value.replace(/\D/g, "");
    // Limita ao tamanho máximo permitido (11 dígitos)
    const limitedValue = numericValue.substring(0, this.maxLength);

    if (limitedValue.length === this.maxLength) {
      return this.format(limitedValue);
    }

    return limitedValue;
  }

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }
}
